import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as GroupIcon } from 'assets/icons/toolbar/group.svg';
import { ReactComponent as UngroupIcon } from 'assets/icons/toolbar/ungroup.svg';
import { groupActiveWidgets, unGroupActiveWidget } from 'modules/Editor/Editor.helpers';
import { useFlow } from 'modules/Editor/components/FlowCore';
import { useAppSelector } from 'modules/Editor/store/hooks';
import { selectHasMultipleActiveWidgets, selectHasSingleGroupSelected } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const GroupWidgetMenu = memo(() => {
  const { t } = useTranslation('editor_toolbar');

  const groupText = t('group.group');
  const unGroupText = t('group.ungroup');

  const hasUngroup = useAppSelector(selectHasSingleGroupSelected);
  const hasGroup = useAppSelector(selectHasMultipleActiveWidgets);
  const { isActiveWidgetsHasLineConnected } = useFlow();

  const onClick = () => {
    if (hasUngroup) return unGroupActiveWidget();
    if (hasGroup) return groupActiveWidgets();
  };

  const isDisabled = (!hasGroup && !hasUngroup) || isActiveWidgetsHasLineConnected;

  let label = groupText;
  let icon = <GroupIcon />;
  if (hasUngroup) {
    label = unGroupText;
    icon = <UngroupIcon />;
  }

  return (
    <Tooltip
      hasArrow
      placement='bottom'
      label={
        <>
          {label} <Keyboard shortcut={['ctrl', 'alt', 'G']} macOs={['⌘', '⌥', 'G']} />
        </>
      }
      bg='black'
    >
      <IconButton
        aria-label={label}
        icon={icon}
        variant='icon-btn-toolbar'
        data-testid='group-widget-menu'
        isActive={hasUngroup}
        isDisabled={isDisabled}
        onClick={onClick}
        size='sm'
      />
    </Tooltip>
  );
});
GroupWidgetMenu.displayName = 'GroupWidgetMenu';
